import type { ReportSchema } from '@ballerine/common';
import { MapPin } from 'lucide-react';
import type { z } from 'zod';

import { ReportWrapper } from '../../report-shared/components';
import { MerchantDetails } from '../components/MerchantDetails';

export const MerchantDetailsSection = ({
  merchantDetails,
  googleMapsApiKey,
}: {
  merchantDetails: NonNullable<z.infer<typeof ReportSchema>['data']>['merchantDetails'];
  googleMapsApiKey?: string | null;
}) => {
  return (
    <ReportWrapper
      Icon={MapPin}
      tooltip="Business registration and headquarters address information."
      showTooltip={false}
    >
      <MerchantDetails
        merchantDetails={merchantDetails}
        googleMapsApiKey={googleMapsApiKey || ''}
      />
    </ReportWrapper>
  );
};
